import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function MenadzmentMalihSrednjihPreduzecaM() {
  return (
    <>
      <Navbar />
      <Bredcom
        title="Početna"
        subtitle="Menadžment Malih i Srednjih Preduzeća"
      />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">
                Menadžment Malih i Srednjih Preduzeća
              </h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Menadžment malih i srednjih
                preduzeća
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 5
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Osnovni cilj predmeta je da studentima predstavi menadžment
                malih i srednjih preduzeća (MMSP) i preduzetništvo u svakom
                pogledu, pogotovo karakteristike i specifičnosti MMSP. Cilj ovog
                predmeta je da u sažetom obliku prikaže istorijski razvoj malog
                i srednjeg biznisa kod nas, obradi iskustva i poglede na MMSP u
                zemljama sa razvijenom tržišnom privredom i zemljama u
                tranziciji, kao i ukaže na perspektive razvoja MSP i
                preduzetništva kod nas u budućnosti.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon uspješnog završetka ovog programskog sadržaja, student je
                osposobljen da: istražuje tržište, izabere djelatnost,
                obračunava troškove (nabavke, proizvodnje, transporta), izabere
                adekvatnu opremu, izabere odgovarajuće ljudske resurse i
                kvalitetan i odgovarajući materijal, da sam napiše i primjeni
                biznis plan itd. Takođe, student je osposobljen da: razumije
                ulogu menadžera, samostalno i timski radi, interaktivno rješava
                probleme, unaprijedi međuljudske odnose, komunicira sa
                dobavljačima i kupcima sa savremenim tehnološkim sredstvima,
                uspješno prezentira svoje zamisli i kvalitete svog proizvoda, a
                sve u cilju što bolje pozicije preduzeća na tržištu i ostvarenja
                što veće dobiti.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava: </strong>
              </p>
              <ul>
                <li>
                  Istorijski aspekt razvoja MSP; Osnivanje novog preduzeća;
                  Preduzetništvo, menadžment i strategije razvoja MSP; Istorija
                  preduzetništva; Odlike i karakteristike vrhunskih
                  preduzetnika; Preduzetništvo i menadžment; Mala i srednja
                  preduzeća i preduzetništvo; Inovacije i rast kao djelovi
                  preduzetništva; Preduzetnik, rizici i stres; Odakle se
                  regrutuju preduzetnici u SAD, Zapadnoj Evropi, Japanu...;
                  Menadžement i MSP; Mjesto i uloga MSP u svjetskoj privredi i
                  okruženju; Franšizing i strategija menadžmenta MSP; Operativno
                  koncipiranje preduzetničkog biznisa; Biznis plan i njegove
                  karakteristike; Izrada biznis plana za kućni biznis;
                  Strategijski biznis plan; Biznis plan za novoosnovano
                  preduzeće; Primjeri biznis planova; Indikatori razvoja MSP.
                </li>
              </ul>
              <p>
                <strong>Praktična nastava</strong> prati teorijsku nastavu.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja se izvode uz korišćenje prezentacija i dodatna
                objašnjenja profesora. Praktična nastava prati teorijska
                predavanja uz primjenu sledećih važnijih metoda: interaktivni
                rad, pojedinačne i grupne prezentacije, analiza praktičnih
                slučajeva, simulacija različitih uloga.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>Istorijski aspekt razvoja MSP</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>Osnivanje novog preduzeća</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>Preduzetništvo, menadžment i strategije razvoja MSP</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>
                      Istorija preduzetništva; Odlike i karakteristike vrhunskih
                      preduzetnika
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Preduzetništvo i menadžment; Mala i srednja preduzeća i
                      preduzetništvo
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P + 2V</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Inovacije i rast kao djelovi preduzetništva; Preduzetnik,
                      rizici i stres
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Odakle se regrutuju preduzetnici u SAD, Zapadnoj Evropi
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Menadžment i MSP; Mjesto i uloga MSP u svjetskoj privredi
                      i okruženju
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>Franšizing i strategija menadžmenta MSP</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>
                      Operativno koncipiranje preduzetničkog biznisa; Biznis
                      plan i njegove karakteristike
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P + 2V</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Izrada biznis plana za kućni biznis; Strategijski biznis
                      plan
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>Biznis plan za novoosnovano preduzeće</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>Primjeri biznis planova; Indikatori razvoja MSP</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 345 h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 215 h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default MenadzmentMalihSrednjihPreduzecaM;
